import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  InitialStatus,
  Name,
  Status,
} from '../../interfaces/OperationsDashboardInterface/OperationsDashboardInterface';

interface OperationState {
  data: Status[];
  nameOrDni: string;
  cartId: string;
  startDate: string;
  endDate: string;
  proposalReference: string;
}

const initialState: OperationState = {
  data: [
    {
      name: Name.ALL,
      initials: InitialStatus.Todas,
      isSelected: true,
    },
    {
      name: Name.PAI,
      initials: InitialStatus.Abonada,
      isSelected: false,
    },
    {
      name: Name.APP,
      initials: InitialStatus.Aprobada,
      isSelected: false,
    },
    {
      name: Name.WTD,
      initials: InitialStatus.Denegada,
      isSelected: false,
    },
    {
      name: Name.TUD,
      initials: InitialStatus.Rechazada,
      isSelected: false,
    },
    {
      name: Name.EXP,
      initials: InitialStatus.Caducada,
      isSelected: false,
    },
    {
      name: Name.TRF,
      initials: InitialStatus.DevTotal,
      isSelected: false,
    },
    {
      name: Name.PRF,
      initials: InitialStatus.DevParcial,
      isSelected: false,
    },
    {
      name: Name.CAP,
      initials: InitialStatus.Captura,
      isSelected: false,
    },
    {
      name: Name.EXT,
      initials: InitialStatus.Ampliada,
      isSelected: false,
    },
  ],
  nameOrDni: '',
  cartId: '',
  startDate: '',
  endDate: '',
  proposalReference: '',
};

export const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    saveFilters: (state, action: PayloadAction<Status[]>) => {
      state.data = action.payload;
    },
    clearFiltersSaved: (state) => {
      state.data = initialState.data;
    },
    saveNameOrDni: (state, action: PayloadAction<string>) => {
      state.nameOrDni = action.payload;
    },
    saveCartId: (state, action: PayloadAction<string>) => {
      state.cartId = action.payload;
    },
    saveStartDate: (state, action: PayloadAction<string>) => {
      state.startDate = action.payload;
    },
    saveEndDate: (state, action: PayloadAction<string>) => {
      state.endDate = action.payload;
    },
    saveProposalRef: (state, action: PayloadAction<string>) => {
      state.proposalReference = action.payload;
    },
  },
});

export const {
  saveFilters,
  clearFiltersSaved,
  saveNameOrDni,
  saveCartId,
  saveStartDate,
  saveEndDate,
  saveProposalRef,
} = filterSlice.actions;

export default filterSlice.reducer;
